module.exports = __webpack_public_path__ + "assets/yuandan.1c9017f8.svg";